import React from 'react';
import { eElement } from '../data/Issues';
import './BacklogFilter.css';

export type tBacklogFilters = {
  epic: string;
  storyPoints: string;
  skill: string;
};

interface BacklogFilterProps {
  filters: tBacklogFilters;
  onFilterChange: (filters: tBacklogFilters) => void;
  availableEpics: string[];
}

export default function BacklogFilter(props: BacklogFilterProps) {
  const handleEpicChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    props.onFilterChange({
      ...props.filters,
      epic: e.target.value
    });
  };

  const handleStoryPointsChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    props.onFilterChange({
      ...props.filters,
      storyPoints: e.target.value
    });
  };

  const handleSkillChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    props.onFilterChange({
      ...props.filters,
      skill: e.target.value
    });
  };

  return (
    <div className="backlog-filter">
      <div className="filter-group">
        <label htmlFor="epic-filter">Epic:</label>
        <select 
          id="epic-filter" 
          value={props.filters.epic} 
          onChange={handleEpicChange}
          className="filter-select"
        >
          <option value="">All Epics</option>
          {props.availableEpics.map((epic) => (
            <option key={epic} value={epic}>{epic}</option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="story-points-filter">Story Points:</label>
        <select 
          id="story-points-filter" 
          value={props.filters.storyPoints} 
          onChange={handleStoryPointsChange}
          className="filter-select"
        >
          <option value="">All</option>
          <option value="1-2">1-2</option>
          <option value="3-4">3-4</option>
          <option value="5-6">5-6</option>
        </select>
      </div>

      <div className="filter-group">
        <label htmlFor="skill-filter">Skill:</label>
        <select 
          id="skill-filter" 
          value={props.filters.skill} 
          onChange={handleSkillChange}
          className="filter-select"
        >
          <option value="">All Skills</option>
          <option value={eElement.UI}>UI</option>
          <option value={eElement.API}>API</option>
          <option value={eElement.Db}>Db</option>
          <option value={eElement.DevOps}>DevOps</option>
        </select>
      </div>
    </div>
  );
}
